import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Group } from 'src/models/DTO/groups/group';
import { GroupCollection } from 'src/models/DTO/groups/groupCollection';
import { Config } from '../../../infrastructure/config';
import { CreateGroupOrderRequestModel } from 'src/models/requestModels/groups/CreateGroupOrderRequestModel';
import { GroupInfo } from 'src/models/DTO/groups/groupInfo';
import { ProductSearchFilter } from 'src/models/DTO/filters/productSearchFilter';

@Injectable({
  providedIn: 'root'
})
export class GroupsService {

  private baseGroupURL: string = Config.api + "group";
  private groupURL : string = Config.api + "group?include=product";
  private createGroupURL: string = Config.api + 'order/group-order'


  constructor(private httpClient: HttpClient) { }

  createGroup(createGroupOrderRequestModel: CreateGroupOrderRequestModel) {
    return this.httpClient.post<any>(this.createGroupURL, createGroupOrderRequestModel);
  }

  getGroup(groupUUID: string) {
    const params = '/' + groupUUID + "?include=product";
    return  this.httpClient.get<GroupInfo>(this.baseGroupURL + params);
  }

  getAllGroups() {
    return this.httpClient.get<GroupCollection>(this.groupURL);
  }


  getFilteredGroups(perPage: number, page: number, query: string = '', sorter: string = 'newest', filters: ProductSearchFilter) {
    let params = '&perPage=' + perPage + '&page=' + page + '&q=' + query;
    filters.filters.forEach(filter => {
      params += '&filter%5B' + filter.key + '%5D=' + filter.value
    })
    params += '&sort=' + sorter;
    return this.httpClient.get<GroupCollection>(this.groupURL + params);

  }

  getAllGroupsByCategory(categoryUUID: string) {
    const params = '?filter%5Bcategory%5D=' + categoryUUID;
    return this.httpClient.get<GroupCollection>(this.groupURL + params);
  }

  getAllGroupsSortedBy(sortedBy: string) {
    const params = '?sort=' + sortedBy;
    return this.httpClient.get<GroupCollection>(this.groupURL + params);
  }

  toggleVisibility(groupUUID: string) {
    const params = '/' + groupUUID + "/participant/toggle-visibility"; 
    return this.httpClient.post(this.groupURL + params, null);
  }}
